angular.module("requestDataCoordBan.components", ['app.services']).component("requestDataCoordBan", {
    templateUrl: "ng/components/varCoordBan/requestData/requestDataCoordBan.view.html",
    bindings: {
        contratti: "=",
        formIsOk: "&",
        formIsNotOk: "&",
        bankCoord: "&"
    },
    controllerAs: "requestDataCoordBanCtrl",
    controller: function RequestDataCoordBan(
        $arcService
    ) {
        var self = this;

        self.$onInit = function () {
            $('#accordion').addClass('p-0');
            self.isPending = false;
            self.contractsList = [];
            self.supportModel = {
                selectedContract: [],
                oldIban: "",
                newIban: ""
            };
            self.getContractsList();
            self.enableNext();
        };

        self.getContractsList = function () {
            $arcService
                .getContracts()
                .then(function (response) {
                    self.contratti.forEach(function (contractSelected) {
                        var listOfContract = response.listContratti.find(function (contract) {
                            return contract.numeroContratto === contractSelected.numero && contract.numeroModulo === contractSelected.modulo;
                        });
                        listOfContract.selected = contractSelected.selected;
                        self.contractsList.push(listOfContract);
                    })
                })
                .catch(function (error) {
                    console.log("ERROR: ", error);
                })
        };

        self.check = function (el) {
            el.selected = !el.selected;

            self.contratti.forEach(function (contratto) {
                if (el.numeroContratto === contratto.numero) {
                    contratto.selected = el.selected;
                }
            });

            self.bankCoord({
                contrattiSelected: self.contratti
            });

            self.enableNext();
        };

        self.enableNext = function () {
            var testContratto = self.contratti.some(function (element) {
                return element.selected == true;
            });

            if (testContratto) {
                self.formIsOk();
            } else {
                self.formIsNotOk();
            }
        }

    }
});